/* ORIGINAL ALBEUX, Task 4 timing: starts the shared 12 second loop of "Discover more" and the Free UK Shipping line.
   The loop must begin at the same instant for both texts, so this adds the class alb-sync to the page once the hero has started
   to play (the hero adds is-playing to itself when its picture is ready). Pages without the hero start at once. If the hero
   never starts (for example the tab is hidden), the loop starts anyway after 4 seconds.

   HERO FAIL-SAFE (1 Nov 2026): the hero picture stays hidden (black) until the hero adds is-playing to itself, and it only does that after its picture is decoded,
   the web fonts are ready and the hero is on screen. On a slow refresh that could take several seconds, or never happen, and the page showed only black.
   Now, if the hero has not started 1.1 seconds after the page is ready, this starts it. It is also started again when the page comes back from the
   browser's back/forward memory. If this script ever fails, a pure CSS safety net in albeux-performance.css shows the picture after 2.2 seconds anyway. */
(function () {
  if (window.__albeuxSync) return;
  window.__albeuxSync = true;
  var root = document.documentElement;
  var started = false;

  function go() {
    if (started) return;
    started = true;
    root.classList.add('alb-sync');
  }

  function startHero(hero) {
    if (hero && !hero.classList.contains('is-playing')) hero.classList.add('is-playing');
  }

  function init() {
    var hero = document.querySelector('.acine');
    if (!hero || hero.classList.contains('is-playing')) { go(); return; }
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (hero.classList.contains('is-playing')) { mo.disconnect(); go(); }
      });
      mo.observe(hero, { attributes: true, attributeFilter: ['class'] });
    }
    setTimeout(function () { startHero(hero); }, 1100);
    setTimeout(go, 4000);
  }

  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) startHero(document.querySelector('.acine'));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();